import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["file", "preview", "image", "text", "remove"]
  static values = { sizeError: String }

  connect() {
    this.originalUrl = this.imageTarget.getAttribute("src")
  }

  disconnect() {
    this.releasePreview()
  }

  choose() {
    const file = this.fileTarget.files[0]
    this.fileTarget.setCustomValidity("")
    if (file && file.size >= 10 * 1024 * 1024) {
      this.fileTarget.setCustomValidity(this.sizeErrorValue)
      this.fileTarget.reportValidity()
      return
    }
    this.releasePreview()
    if (file) {
      this.previewUrl = URL.createObjectURL(file)
      this.imageTarget.src = this.previewUrl
      this.previewTarget.hidden = false
      this.textTarget.open = false
      if (this.hasRemoveTarget) this.removeTarget.checked = false
    } else {
      this.restorePreview()
    }
  }

  remove() {
    this.releasePreview()
    if (this.removeTarget.checked) {
      this.fileTarget.value = ""
      this.fileTarget.setCustomValidity("")
      this.previewTarget.hidden = true
      this.textTarget.open = true
    } else {
      this.restorePreview()
    }
  }

  restorePreview() {
    const visible = this.originalUrl && !(this.hasRemoveTarget && this.removeTarget.checked)
    this.previewTarget.hidden = !visible
    if (visible) this.imageTarget.src = this.originalUrl
    this.textTarget.open = !visible
  }

  releasePreview() {
    if (this.previewUrl) URL.revokeObjectURL(this.previewUrl)
    this.previewUrl = null
  }
}
